import classNames from 'classnames';
import PropTypes from 'prop-types';
import { BASKET_SOCIAL_CUES_NON_ATOL } from '../../brands/default/content/components/checkout';
import CheckoutSocialCue from './SocialCue';

const BasketSocialCuesNonAtol = ({ className, isLighter }) => (
  <>
    <div className={classNames('social-cues', className)}>
      <CheckoutSocialCue
        isLighter={isLighter}
        text={BASKET_SOCIAL_CUES_NON_ATOL.noQuibble}
        type="assure"
      />
      <CheckoutSocialCue
        isLighter={isLighter}
        text={BASKET_SOCIAL_CUES_NON_ATOL.changeYourMind}
        type="assure"
      />
    </div>
    <style jsx>{`
      .with-margin {
        margin: 15px 0;
      }
    `}</style>
  </>
);

BasketSocialCuesNonAtol.propTypes = {
  className: PropTypes.string,
  isLighter: PropTypes.bool,
};

BasketSocialCuesNonAtol.defaultProps = {
  isLighter: false,
};

export default BasketSocialCuesNonAtol;
